<template>
  <v-expansion-panels>
    <v-subheader><h3>Administración de Usuarios</h3></v-subheader>
    <v-expansion-panel>
      <v-expansion-panel-header>Usuarios</v-expansion-panel-header>
      <v-expansion-panel-content>
        <UserGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Roles</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RoleGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Rol - Usuario</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RoleUserGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-subheader><h3>Administración de Permisos</h3></v-subheader>

        <v-expansion-panel>
      <v-expansion-panel-header>Procesos</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ProcessGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Permisos</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RoleRightsGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--<v-subheader>Administracion de Claves</v-subheader>

    <v-expansion-panel>
      <v-expansion-panel-header>Claves</v-expansion-panel-header>
      <v-expansion-panel-content>
        <ApiKeyGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>-->

    <v-subheader><h3>Administración de Menus</h3></v-subheader>

    <v-expansion-panel>
      <v-expansion-panel-header>Menus</v-expansion-panel-header>
      <v-expansion-panel-content>
        <MenuGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Menu - Usuario</v-expansion-panel-header>
      <v-expansion-panel-content>
        <UserMenuGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

   <v-subheader><h3>Administración de BlackOut</h3></v-subheader>

    <v-expansion-panel>
      <v-expansion-panel-header>BlackOut</v-expansion-panel-header>
      <v-expansion-panel-content>
        <BlackOutGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-subheader><h3>Administración de Comunicaciones</h3></v-subheader>

    <v-expansion-panel>
      <v-expansion-panel-header>Status Ordenes</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RepOrderStatusGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Status Items Ordenes</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RepOrderItemStatusGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Procesos Ordenes</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RepOrderProcessGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Plantillas Ordenes</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RepOrderTemplateGrid/>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-header>Orden</v-expansion-panel-header>
      <v-expansion-panel-content>
        <RepOrderForm/>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</template>

<script>
import UserGrid from './UserGrid'
import RoleGrid from './RoleGrid'
import RoleUserGrid from './RoleUserGrid'
import RoleRightsGrid from './RoleRightsGrid'
import ProcessGrid from './ProcessGrid'
import ApiKeyGrid from './ApiKeyGrid'
import UserMenuGrid from './UserMenuGrid'
import MenuGrid from './MenuGrid'
import BlackOutGrid from './BlackOutGrid'
import RepOrderStatusGrid from './RepOrderStatusGrid'
import RepOrderItemStatusGrid from './RepOrderItemStatusGrid'
import RepOrderTemplateGrid from './RepOrderTemplateGrid'
import RepOrderProcessGrid from './RepOrderProcessGrid'
import RepOrderForm from './RepOrderForm'

export default {
  components: {
    UserGrid,
    RoleGrid,
    RoleUserGrid,
    RoleRightsGrid,
    ProcessGrid,
    ApiKeyGrid,
    UserMenuGrid,
    MenuGrid,
    BlackOutGrid,
    RepOrderStatusGrid,
    RepOrderItemStatusGrid,
    RepOrderTemplateGrid,
    RepOrderProcessGrid,
    RepOrderForm
  },
  created () {
    this.$store.commit('updateTitle', 'Panel de Administración')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Administration.vue